import { useState, useEffect, useRef } from "react";
import logo1 from "../src/logo.png"


const SERVICES = [
  "Product/Service development",
  "Communication to customers",
  "Marketing information systems",
];

const TOOLS = [
  "• Web development",
  "• App development",
  "• Photography",
  "• Videography",
  "• Cyber security",
];

const TEAM = [
  "Paul Blunck",
  "Amaris Nagori",
  "Mahmoud Al-Saraj",
];

export default function BlunckPage() {
  const [prog, setProg] = useState(0);
  const cur = useRef(0);
  const tgt = useRef(0);
  const raf = useRef(null);

  useEffect(() => {
    const tick = () => {
      const d = tgt.current - cur.current;
      if (Math.abs(d) > 0.0002) {
        cur.current += d * 0.1;
        setProg(cur.current);
      }
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);

    const onWheel = (e) => {
      e.preventDefault();
      tgt.current = Math.min(1, Math.max(0, tgt.current + e.deltaY * 0.0014));
    };
    let ty = 0;
    const onTS = (e) => { ty = e.touches[0].clientY; };
    const onTM = (e) => {
      e.preventDefault();
      const d = ty - e.touches[0].clientY;
      ty = e.touches[0].clientY;
      tgt.current = Math.min(1, Math.max(0, tgt.current + d * 0.005));
    };

    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("touchstart", onTS, { passive: true });
    window.addEventListener("touchmove", onTM, { passive: false });
    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("touchstart", onTS);
      window.removeEventListener("touchmove", onTM);
    };
  }, []);

  const p = 1 - Math.pow(1 - Math.min(prog, 1), 4);

  // Subtitle fades out first: fully gone by p=0.25
  const subtitleOpacity = Math.max(0, 1 - p / 0.25);

  // Logo only starts moving after p=0.3 (after subtitle is gone)
  const logoP = Math.max(0, (p - 0.3) / 0.7);
  const logoEased = 1 - Math.pow(1 - logoP, 4);
  const logoScale = 1 - logoEased * (1 - 42 / 110);
  const logoTopPct = (1 - logoEased) * 50;
  const logoTopPx  = logoEased * 32;
  const logoTY     = (1 - logoEased) * -50;

  const cRaw = Math.max(0, (p - 0.4) / 0.6);
  const cp   = 1 - Math.pow(1 - cRaw, 3);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@500;600;700;900&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        html, body {
          width: 100vw;
          height: 100vh;
          overflow: hidden;
          background: #fff;
        }

        .stage {
          position: relative;
          width: 100vw;
          height: 100vh;
          overflow: hidden;
          background: #fff;
        }

        .logo-wrap {
          position: absolute;
          left: 50%;
          z-index: 20;
          white-space: nowrap;
          transform-origin: center center;
        }

        .logo-img {
          display: block;
          height: 180px;
          width: auto;
          -webkit-font-smoothing: antialiased;,
        }

        .logo2 {
          font-family: 'Nunito', sans-serif;
          font-weight: 600;
          font-size: 66px;
          margin-top:30px
        }

        .second-page {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding-top: 80px;
        }

        .cols {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: space-between;
          width: 100%;
          max-width: 1100px;
          padding: 0 80px;
          gap: 0;
          margin-top: 50px;
        }

        .col {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1;
        }

        .col-center {
          align-items: center;
        }

        .pill {
          background: black;
          border-radius: 999px;
          padding: 10px 32px;
          font-family: 'Nunito', sans-serif;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 40px;
          white-space: nowrap;
        }

        .items {
          display: flex;
          flex-direction: column;
          gap: 22px;
          width: 100%;
        }

        .col-center .items {
          align-items: center;
        }

        .item {
          font-family: 'Nunito', sans-serif;
          font-size: 19px;
          font-weight: 500;
          color: #111;
          line-height: 1.3;
          text-align: center;
        }

        .item-left {
          text-align: left;
          display: flex;
          align-items: baseline;
          gap: 10px;
        }

        .bullet {
          font-size: 19px;
          color: #111;
          flex-shrink: 0;
          line-height: 1.3;
        }
      `}</style>

      <div className="stage">

        {/* Logo */}
        <div
          className="logo-wrap"
          style={{
            top: `calc(${logoTopPct}% + ${logoTopPx}px)`,
            transform: `translateX(-50%) translateY(${logoTY}%) scale(${logoScale})`,
          }}
        >
          <img src={logo1} alt="blunck" className="logo-img" />

          {/* Subtitle — fades out as scroll begins, hidden when gone */}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              opacity: subtitleOpacity,
              visibility: subtitleOpacity < 0.01 ? "hidden" : "visible",
            }}
          >
            <span className="logo2">Marketing Systems</span>
          </div>
        </div>

        {/* Second page */}
        <div
          className="second-page"
          style={{
            opacity: cp,
            visibility: cp < 0.01 ? "hidden" : "visible",
            transform: `translateY(${(1 - cp) * 24}px)`,
            pointerEvents: cp > 0.05 ? "auto" : "none",
          }}
        >
          <div className="cols">

            <div className="col">
              <span className="pill">Services</span>
              <div className="items">
                {SERVICES.map((s) => (
                  <p className="item item-left" key={s}>
                    <span className="bullet">•</span>
                    <span>{s}</span>
                  </p>
                ))}
              </div>
            </div>

            <div className="col col-center">
              <span className="pill">Tools</span>
              <div className="items">
                {TOOLS.map((t) => (
                  <p className="item" key={t}>{t}</p>
                ))}
              </div>
            </div>

            <div className="col col-center">
              <span className="pill">Team</span>
              <div className="items">
                {TEAM.map((m) => (
                  <p className="item" key={m}>{m}</p>
                ))}
              </div>
            </div>

          </div>
        </div>

      </div>
    </>
  );
}